<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte de ingresos</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RI_02_ingresos</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Búsqueda de clinicas </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group
                align="left"
                v-if="$localStorageService.can('RI_01_ver_clinicas')"
              >
                <label for="clinica">Clinicas</label>
                <v-select
                  v-if="!todas"
                  name="clinica"
                  placeholder="Clinicas"
                  label="strNombre"
                  multiple
                  :reduce="(variable) => variable.idClinica"
                  :options="clinicas"
                  v-model="filtro.idClinicas"
                ></v-select>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="todas"
                  name="checkbox-1"
                  @change="todos()"
                >
                  Todas las clinicas
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="fci">Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Inicio"
                    v-model="$v.filtro.fechaInicio.$model"
                    :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label for="fcf">Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Fin"
                    :min="filtro.fechaInicio"
                    :max="new Date()"
                    v-model="$v.filtro.fechaFin.$model"
                    :state="validateState('fechaFin')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                variant="outline-primary"
                :disabled="loader"
                @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="12">
          <download-excel
            v-if="datosTabla.length > 0"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="IngresosClinicas"
            name="reporte de ingresos.xls"
          >
            Generar Excel
            <em class="fa fa-file-excel-o"></em>
          </download-excel>
          <b-col v-if="datosFaltantes">
            <span style="color: red"
              ><small
                >*** Los datos pueden no ser los correctos ya que no se cuenta
                con la información necesasia del tratamiento</small
              ></span
            >
          </b-col>
        </b-col>
        <b-col cols="12">
          <div v-if="!loader" class="overflow-auto">
            <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              striped
              responsive="true"
              class="parrafos"
            >
              <template v-slot:cell()="{ item, field: { key } }">
                <span
                  class="adquisicionSpan"
                  v-if="item[key] == 'Co.Adquisicion:'"
                >
                  <span
                    v-if="adquisiciones.length != 0"
                    @click="$bvModal.show('adquisiciones')"
                  >
                    Co.Adquisicion:
                  </span>

                  <span v-else> Co.Adquisicion: </span>
                </span>
                <span v-else>{{ item[key] }}</span>
              </template>
            </b-table>
          </div>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="buscado">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show
              >No hay datos</b-alert
            >
          </b-col>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="adquisiciones"
      title="Costos de Adquisición"
      ref="adquisiciones"
      size="lg"
      hide-footer
    >
      <b-table
        id="Pendientes"
        thead-tr-class="columnas"
        :items="adquisiciones"
        :fields="fieldsAdquisiciones"
        striped
        responsive="true"
        class="parrafos"
      >

        <template #cell(costo)="data"> {{ data.value | monedaEntero }} </template>

        <template #cell(coPago)="data"> {{ data.value | monedaEntero }} </template>

        <template #cell(traspaso)="data"> {{ data.value | monedaEntero }} </template>

        <template #cell(honorario)="data"> {{ data.value | monedaEntero }} </template>

        <template #cell(tieneHonorarioTabla)="data"> {{ data.value | sino }} </template>
      </b-table>
      <span class="badgeCss">
        <b-badge variant="primary" class="badgeTxt" align="left">
          Total {{ totalAdquisiciones | monedaEntero }}</b-badge>

        <b-badge v-if="numeroTratamientos !== undefined">
          {{numeroTratamientosSinCosto}} de {{numeroTratamientos}} tratamientos no tienen honorarios para el cálculo del costo de adquisición
        </b-badge
        >
      </span>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      buscado: false,
      datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,

      datosTablaDetalle: [],
      fieldsDetalle: [
        { key: "fecha", label: "Fecha", sortable: true },
        { key: "ingreso", label: "monto", sortable: true },
      ],
      registrosPorPaginaDetalle: 10,
      paginaActualDetalle: 0,

      show: false,
      filtro: {
        idClinicas: [],
        fechaInicio: null,
        fechaFin: null,
      },

      clinicas: [],
      todas: false,
      datosFaltantes: false,
      fieldsExcel: "",
      adquisiciones: [],
      fieldsAdquisiciones: [
        {
          key: "idTratamiento",
          label: "ID",
        },
        {
          key: "tratamiento",
          label: "Tratamiento",
        },
        {
          key: "coPago",
          label: "Copago",
        },
        {
          key: "traspaso",
          label: "Traspaso",
        },
        {
          key: "honorario",
          label: "Honorario",
        },
        {
          key: "costo",
          label: "Costo de Adquisición",
        },
        {
          key: "tieneHonorarioTabla",
          label: "Tiene costo definido"
        }
      ],
      totalAdquisiciones: null,
      numeroTratamientos: null,
      numeroTratamientosSinCosto: null
    };
  },
  validations: {
    filtro: {
      fechaInicio: { required },
      fechaFin: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerClinicas();
    this.filtro.idClinicas = [this.$localStorageService.getIdClinica()];
  },
  methods: {
    obtenerClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.clinicas = respuesta.data.data;
          }
        });
    },
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.todas && this.filtro.idClinicas.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {
          this.loader = true;
          this.buscado = false;
          this.datosFaltantes = false;
          this.datosTabla = [];

          const envio = {
            idClinicas: this.todas ? [-1] : this.filtro.idClinicas,
            fechaInicio: this.$moment(this.filtro.fechaInicio)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(this.filtro.fechaFin)
              .add(1, "days")
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            horas: this.$horas(),
          };

          this.$http
            .post(this.$api + "finanzas/reporte/ingresos", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.armarFields(respuesta.data.data.clinicas);
                this.armarFilas(respuesta.data.data.filas);
                this.datosFaltantes = respuesta.data.data.datosFaltantes;
              }
            })
            .finally(() => {
              this.loader = false;
              this.buscado = true;
            });
        }
      }
    },
    armarFields(item) {
      let excel = '{ "Fecha" : "nombreFila" ';
      this.fields = [{ key: "nombreFila", label: "Fecha", variant: "primary" }];

      item.forEach((item) => {
        this.fields.push({
          key: item.idClinica.toString(),
          label: item.strNombre.toString(),
        });
        excel =
          excel +
          ', "' +
          item.strNombre.toString() +
          '":' +
          '"' +
          item.idClinica.toString() +
          '"';
      });

      excel = excel + ',"Total": "total"}';

      this.fields.push({ key: "total", label: "Total" });
      this.fieldsExcel = JSON.parse(excel);
    },
    armarFilas(item) {
      this.datosTabla = [];
      this.adquisiciones = [];
      this.totalAdquisiciones = 0;

      item.forEach((item) => {
        let dato = '{"nombreFila":' + '"' + item.nombreFila + '"';

        let suma = 0;
        // let adquisiciones = [];
        item.clinicas.map((it) => {
          if (it.adquisiciones != null) {
            it.adquisiciones.forEach((ad) => {
              this.totalAdquisiciones += ad.costo;
              this.adquisiciones.push(ad);
            });
          }

          if (item.nombreFila.includes("%")) {
            dato =
              dato +
              "," +
              ' "' +
              it.idClinica +
              '" ' +
              " : " +
              ' "' +
              it.valor +
              '%"';
          } else {
            dato =
              dato +
              "," +
              ' "' +
              it.idClinica +
              '" ' +
              " : " +
              ' "' +
              this.$options.filters.monedaEntero(it.valor) +
              '"';
          }
          suma = suma + it.valor;
        });

        if (!item.nombreFila.includes("%")) {
          dato =
            dato +
            "," +
            ' "total": "' +
            this.$options.filters.monedaEntero(suma) +
            '"';
        } else {
          dato = dato + "," + ' "total": "0%"';
        }

        dato = dato + "}";


        this.datosTabla.push(JSON.parse(dato));
      });

      const totalTraspaso = this.datosTabla.filter(it=>it.nombreFila==='Traspaso C.');
      const totalICT = this.datosTabla.filter(it=>it.nombreFila==='ICT');
      const totalPorcentajeTraspaso = this.datosTabla.filter(it=>it.nombreFila==='% Traspasos');

      const valorTotalTraspaso = totalTraspaso !== undefined && totalTraspaso !== null && totalTraspaso.length > 0 ? Number(totalTraspaso[0].total.replaceAll('$', '').replaceAll(',', '')) : 0;
      const valorTotalICT = totalICT !== undefined && totalICT !== null && totalICT.length > 0 ? Number(totalICT[0].total.replaceAll('$', '').replaceAll(',', '').trim()) : 0;

      if (totalPorcentajeTraspaso !== undefined && totalPorcentajeTraspaso !== null && totalPorcentajeTraspaso.length > 0 ) {
        totalPorcentajeTraspaso[0].total =  this.$options.filters.numeroDosDecimales((valorTotalTraspaso/valorTotalICT) * 100)  + '%';
      }


    },
    detalle(item) {
      this.datosTablaDetalle = item.detalle;
      this.registrosPorPaginaDetalle = 10;
      this.paginaActualDetalle = 0;
      this.show = true;
    },
    cerrarModal() {
      this.show = false;
    },
    todos() {
      this.todas = !this.todas;
      this.filtro.idClinicas = [];
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped>
.adquisicionSpan {
  cursor: pointer;
  text-decoration: underline;
  color: #00458b;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.badgeTxt {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}
</style>
